/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import { string, object, bool } from 'prop-types';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import SubscriptionTermOfUse from './SubscriptionTermOfUse';

const styles = (theme) => ({
    subscriptionDetailsContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px',
    },
    subscriptionDetails: {
        display: 'block',
        fontSize: 14,
        width: 399,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        margin: '0 auto',
        '& ul': {
            marginBottom: 0,
            lineHeight: '20px',
            marginTop: 20,
            paddingLeft: 10,
            [theme.breakpoints.down('xs')]: {
                paddingLeft: 40,
                marginTop: 10,
            },

        },
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
            display: 'inline-block',
        },
    },
    detailWrapper: {
        borderTop: '1px solid #C4C4C4',
        paddingTop: '28px',
        marginTop: '20px',
        '& ul': {
            width: '307px',
            margin: '0 auto',
            paddingLeft: '10px',
            '& li': {
                fontSize: '14px',
                width: '294px',
                lineHeight: '20px',
                marginBottom: '8px',
            },
            [theme.breakpoints.up('600')]: {
                width: '86.8%',
                '& li': {
                    width: '100%',
                },
            },
        },
        [theme.breakpoints.up('600')]: {
            width: '100%',
            paddingTop: '24px',
        },
    },
});

const renderers = (handleModal, handleCancelModal) => ({
    linkReference: (props) => {
        const { href, children } = props;
        if (href === '/terms-and-conditions-modal') {
            return (
                <span key={1} role="link" tabIndex={0} onClick={(e) => { handleModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>
                    {children}
                </span>
            );
        } if (href === '/cancel-subscription-modal') {
            return (
                <span key={1} role="link" tabIndex={0} onClick={(e) => { handleCancelModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>
                    {children}
                </span>
            );
        }
        return children;
    },
});

const SubscriptionPDPInformation = ({ copy, classes, isPdpRedesignEnabled }) => {
    const [open, setOpen] = useState(false);
    const [subscriptionCancelModalOpen, setSubscriptionCancelModalOpen] = useState(false);
    const handleModal = (e, windowOpen) => {
        e.nativeEvent.stopImmediatePropagation();
        e.preventDefault();
        e.stopPropagation();
        setOpen(windowOpen);
    };
    const handleCancelModal = (e, windowOpen) => {
        e.nativeEvent.stopImmediatePropagation();
        e.preventDefault();
        e.stopPropagation();
        setSubscriptionCancelModalOpen(windowOpen);
    };
    const defaultCopy = (
        <ul>
            <li>Payment method on file will be charged on a recurring basis</li>
            <li>You may cancel at any time before your next order is processed. To learn how to cancel, <span key={1} role="link" tabIndex={0} onClick={(e) => { handleCancelModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>click here</span> </li>
            <li>To learn more, see <span key={1} role="link" tabIndex={0} onClick={(e) => { handleModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>Subscription Program Terms and Conditions</span></li>
        </ul>
    );
    return (
        <>
            <Grid container className={classes.subscriptionDetailsContainer} data-testid="subscription-details">
                <Grid item xs={12} sm={12}>
                    <Typography className={`${classes.subscriptionDetails} ${isPdpRedesignEnabled ? classes.detailWrapper : ''}`}>
                        {copy ? <ReactMarkdown source={copy} renderers={renderers(handleModal, handleCancelModal)} escapeHtml={false} /> : defaultCopy}
                    </Typography>
                </Grid>
            </Grid>
            {open && <SubscriptionTermOfUse open={open} setOpen={setOpen} />}
            {subscriptionCancelModalOpen && <CancelSubscriptionModal open={subscriptionCancelModalOpen} setSubscriptionCancelModalOpen={setSubscriptionCancelModalOpen} />}
        </>
    );
};
SubscriptionPDPInformation.propTypes = {
    classes: object.isRequired,
    copy: string.isRequired,
    isPdpRedesignEnabled: bool,
};
SubscriptionPDPInformation.defaultProps = {
    isPdpRedesignEnabled: false,
};

export default withStyles(styles)(SubscriptionPDPInformation);
